import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';

const ProductsContext = createContext({ products: [], refreshProducts: () => {} });

export function ProductsProvider({ children }) {
  const { user, company } = useAuth();
  const userId = user?.id;
  const companyId = company?.id;
  const [products, setProducts] = useState([]);

  const fetchProducts = useCallback(() => {
    if (!userId || !companyId) return;
    api.get('/products?per_page=5000').then(r => setProducts(r.data.items || r.data)).catch(() => {});
  }, [userId, companyId]);

  useEffect(() => { fetchProducts(); }, [fetchProducts]);

  // Yeni ürün eklenince context'i güncelle
  useEffect(() => {
    const channel = new BroadcastChannel('erp_product_created');
    channel.onmessage = (e) => {
      const { product_id, product_name, product_code } = e.data;
      setProducts(prev => {
        if (prev.find(p => p.id === product_id)) return prev;
        return [...prev, { id: product_id, name: product_name, code: product_code }];
      });
    };
    return () => channel.close();
  }, []);

  // Ürün kartı DÜZENLENİNCE listeyi tazele.
  //
  // Liste oturum başında bir kez çekiliyordu; kartta KDV oranı, birim ya da
  // fiyat değiştirildiğinde açık duran fatura ekranı eski değeri kullanmaya
  // devam ediyordu. KDV oranı faturada kart değerine göre KİLİTLİ gösterildiği
  // için kullanıcı yanlış oranı görüp değiştiremiyordu.
  useEffect(() => {
    const channel = new BroadcastChannel('erp_product_updated');
    channel.onmessage = () => fetchProducts();
    return () => channel.close();
  }, [fetchProducts]);

  return (
    <ProductsContext.Provider value={{ products, refreshProducts: fetchProducts }}>
      {children}
    </ProductsContext.Provider>
  );
}

export function useProducts() {
  return useContext(ProductsContext);
}
